import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Icon, Uploader, ButtonToolbar } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import AppContext from '../../../context/AppContext'
import pathname from '../../../constants/pathname'
import {
  processFileImport,
  processGradeFileImport,
  saveDataFromFileImport,
  saveDataFromGradeFileImport,
} from '../../../redux/actions/auditReportSummary'
import { isEmpty } from 'lodash-es'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import DataImportTable from './DataImportTable'

export default function DataImportTableWidget(props) {
  const { theme } = React.useContext(AppContext)
  const { type } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  // const [formSchema, setFormSchema] = useState(props.schema)
  const [isFileImport, setIsFileImport] = useState(true)
  const [dataImportFile, setDataImportFile] = useState()

  let history = useHistory()

  // console.log('typetypetypetypetypetype => ', type)

  let header =
    type == 'imp01'
      ? 'นำเข้าข้อมูลโครงการสำหรับตรวจสอบข้อมูล'
      : type == 'imp02'
      ? 'นำเข้าข้อมูลโครงการสุ่มตรวจ'
      : 'นำเข้าข้อมูลเกรด'

  const handleSubmitImportFile = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const file = getValues('fileImport')

      const formData = new FormData()
      file &&
        file?.forEach((element) => {
          formData.append(`File`, element.blobFile)
        })

      formData.append('ImportType', type)

      let response
      if (type == 'imp03') {
        response = await processGradeFileImport(formData)
      } else {
        response = await processFileImport(formData)
      }

      if (response) {
        setDataImportFile(response.model)
      } else {
        setError(response?.errorMessage || DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCacel = () => {
    setIsFileImport(false)
    setDataImportFile()
  }

  const handleSave = async (rowData) => {
    startLoading()
    setIsLoading(true)
    try {
      var datas = {}
      Object.assign(datas, { datas: rowData, importType: type })

      // console.log('saveeeee => ', datas)
      let response
      if (type == 'imp03') {
        response = await saveDataFromGradeFileImport(datas)
      } else {
        response = await saveDataFromFileImport(datas)
      }

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        history.push(`${pathname.audit.AuditReportSummary}`)
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_FAILED_MSG,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCancelGoback = () => {
    history.push(`${pathname.audit.AuditReportSummary}`)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {!dataImportFile && (
        <Panel shaded collapsible defaultExpanded header={'แนบไฟล์'} bordered>
          <Row style={{ marginTop: 10 }}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Controller
                name={`fileImport`}
                control={control}
                defaultValue={''}
                render={(props) => {
                  return (
                    <Uploader
                      draggable
                      accept={'.xlsx'}
                      autoUpload={false}
                      multiple={false}
                      fileList={props.value || []}
                      onChange={(fileList) => {
                        if (isEmpty(fileList)) {
                          props.onChange(undefined)
                        } else {
                          // props.onChange(fileList)

                          setIsFileImport(false)
                          let files = []
                          files.push(fileList[fileList.length - 1])
                          props.onChange(files)
                        }
                      }}
                    >
                      <div>
                        <div
                          style={{ lineHeight: '50px' }}
                          className={classNames('uploader', `${theme[0]}-background`)}
                        >
                          <Icon size="4x" icon="upload2" />
                          <small className="uploder__text">
                            <p style={{ wordBreak: 'break-word' }}>
                              คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                            </p>
                          </small>
                        </div>
                      </div>
                    </Uploader>
                  )
                }}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            {/* <hr /> */}
            <ButtonToolbar style={{ textAlign: 'right' }}>
              <SaveButton icon={'import'} onClick={handleSubmitImportFile} disabled={isFileImport}>
                {'Process'}
              </SaveButton>

              <CancelButton
                onClick={() => {
                  handleCancelGoback()
                }}
              >
                {'ยกเลิก'}
              </CancelButton>
            </ButtonToolbar>
          </Row>
        </Panel>
      )}

      {dataImportFile && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={header}
          bordered
          style={{ marginTop: 20, marginBottom: 20 }}
        >
          <DataImportTable
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            schema={dataImportFile}
            onCancel={handleCacel}
            onSave={handleSave}
            type={type}
            // isViewMode={!formSchema?.form?.isEnableEdit}
            // onViewHistory={onViewHistory}
          />
        </Panel>
      )}
    </>
  )
}
